import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { typography, spacing } from '../../tokens';

export type TagStatus = 'join' | 'replies' | 'set';

export interface TagProps {
  /**
   * The tag status that determines the color scheme
   */
  status: TagStatus;

  /**
   * The text content to display
   */
  text: string;

  /**
   * Test ID for testing
   */
  testID?: string;
}

const statusStyles: Record<TagStatus, { backgroundColor: string; textColor: string }> = {
  join: {
    backgroundColor: '#D0E5F9',
    textColor: '#4A90E2',
  },
  replies: {
    backgroundColor: '#D3F4E7',
    textColor: '#24835D',
  },
  set: {
    backgroundColor: '#4F5667',
    textColor: '#ECEEF1',
  },
};

export const Tag: React.FC<TagProps> = ({
  status,
  text,
  testID,
}) => {
  const { backgroundColor, textColor } = statusStyles[status];

  return (
    <View
      style={[styles.container, { backgroundColor }]}
      testID={testID}
      accessibilityRole="text"
      accessibilityLabel={`${status}: ${text}`}
    >
      <Text style={[styles.text, { color: textColor }]}>{text}</Text>
    </View>
  );
};

Tag.displayName = 'Tag';

const styles = StyleSheet.create({
  container: {
    height: 24,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
    borderRadius: 99, // Full pill shape
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-start',
  },
  text: {
    ...typography.label.medium,
  },
});
